export const SOURCE_TYPE_PICKER = 'source-type-picker'
export const MORE_STYLES_BUTTON = 'more-styles-button'
export const SOURCE_TYPE_BUTTON = (type: string) => `${type}-button`
